export const API_URL = '/ajax';



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/token.service.ts